import { render, staticRenderFns } from "./kegiatanLainnya.vue?vue&type=template&id=fb7b9b6e&"
import script from "./kegiatanLainnya.vue?vue&type=script&lang=js&"
export * from "./kegiatanLainnya.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports